import type { AssetsApi, AssetsApiOutputs } from '@ipen-portal/backstage-plugin-assets-backend';
import type { TRPCOptionsProxy } from '@ipen-portal/plugin-trpc-react';

import { createApiRef, useApi } from '@backstage/frontend-plugin-api';

export const assetsApiRef = createApiRef<TRPCOptionsProxy<AssetsApi>>().with({
  id: 'plugin.assets.api',
});

export type Asset = AssetsApiOutputs['get'];
export type AssetMetadata = Pick<Asset, 'description' | 'ownerEntityRef' | 'path' | 'tags'>;
export type MediaLimits = AssetsApiOutputs['capabilities']['mediaTypes'];

export const useAssetsApi = () => useApi(assetsApiRef);
